// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1ZIdA","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__FcToi"};